import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FormatSettings } from '@progress/kendo-angular-dateinputs';
import { NotificationService } from '@progress/kendo-angular-notification';
import { AdminService } from 'src/app/modules/administration/services/admin.service';
import {
  dialogAnimationDuration,
  dialogTimer,
} from 'src/app/shared/constants/dialog-specs';
import { AgencyRequest } from 'src/app/modules/administration/interfaces/add-to-worklist';
import { SearchGlobalWorklistRequest } from 'src/app/modules/administration/interfaces/search-global-worklist';
import { VwCompleteWorklist } from 'src/app/modules/administration/interfaces/complete-worklist';
import { NOTIFICATION_MESSAGES } from 'src/app/shared/constants/notification-messages';
import { VwAgency } from '../../interface/agency-list';

@Component({
  selector: 'app-waitlist-student',
  templateUrl: './waitlist-student.component.html',
  styleUrls: ['./waitlist-student.component.scss'],
  standalone: false,
})
export class WaitlistStudentComponent implements OnInit {
  students: VwCompleteWorklist[];
  @Input() agencySk: string;
  showResults: boolean = false;
  @Input() showSearchModal: boolean = false;
  searchFormGroup!: FormGroup;
  gridFormGroup!: FormGroup;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  loadSpinner: boolean;
  public format: FormatSettings = {
    displayFormat: 'MM/dd/yyyy',
    inputFormat: 'MM/dd/yyyy',
  };
  public agencyList: {
    text?: string;
    value?: string;
    buildingCode?: string;
  }[] = [];

  constructor(
    library: FaIconLibrary,
    private adminService: AdminService,
    private fb: FormBuilder,
    private notificationService: NotificationService
  ) {
    library.addIcons(faPlus);
    this.createForm();
  }

  ngOnInit(): void {
    if (this.agencySk) {
      this.getMDEAgencyListByAgencySk();
    }
  }

  private createForm(): void {
    this.searchFormGroup = this.fb.group({
      nycId: new FormControl('', Validators.required),
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      dob: new FormControl(''),
      birthDate: new FormControl('', Validators.required), //TODO: adjust to the other instantiation way, without using new FormControl
    });

    this.gridFormGroup = this.fb.group({
      siteName: new FormControl('', Validators.required),
    });
  }

  studentSearch(): void {
    if (this.searchFormGroup.invalid) {
      return;
    }
    this.loadSpinner = true;
    this.showResults = true;
    const studentObj: SearchGlobalWorklistRequest = {
      firstName: this.searchFormGroup.get('firstName')?.value,
      lastName: this.searchFormGroup.get('lastName')?.value,
      birthDate:
        this.searchFormGroup.get('birthDate')?.value !== ''
          ? this.searchFormGroup.get('birthDate')?.value
          : null,
      nycId: this.searchFormGroup.get('nycId')?.value
        ? this.searchFormGroup.get('nycId')?.value.toString()
        : '',
    };
    this.adminService
      .getStudentSearchDetails(studentObj)
      .subscribe((response: VwCompleteWorklist[]) => {
        this.students = [...response];
        this.loadSpinner = false;
      });
  }
  addMdeWaitlist(data: AgencyRequest): void {
    this.loadSpinner = true;

    const payload: AgencyRequest = {
      agencyLocationSk: this.gridFormGroup?.value?.siteName?.value,
      studentSk: data?.studentSk,
    };

    this.adminService.addToWaitlist(payload).subscribe((response: boolean) => {
      if (response) {
        this.notificationService.show({
          content: NOTIFICATION_MESSAGES.submitSuccess,
          cssClass: 'notification-success',
          hideAfter: dialogTimer,
          position: { horizontal: 'center', vertical: 'top' },
          animation: { type: 'slide', duration: dialogAnimationDuration },
          type: { style: 'success', icon: true },
        });
        this.loadSpinner = false;
        this.closeModal.next();
      }
    });
  }

  getMDEAgencyListByAgencySk(): void {
    this.adminService
      .getMDEAgencyListByAgencySk(this.agencySk)
      .subscribe((response: VwAgency[]) => {
        this.agencyList = response.map((item: VwAgency) => ({
          text: item?.siteLocation,
          value: item?.agencyLocationSk,
          buildingCode: item?.buildingCode,
        }));
      });
  }

  onHideHandler(): void {
    this.createForm();
    this.showResults = false;
    this.closeModal.next();
  }
}
